import { TextField } from '@mui/material';
import CloseMIcon from 'crono-fe-common/icons/Icon-Close';
import EditIcon from 'crono-fe-common/icons/Icon-Edit';
import { colors } from 'crono-fe-common/theme';
import { useState } from 'react';

interface IProps {
  value: string;
  remove: () => void;
  editOption: (newValue: string) => void;
}

const SingleOptionMultiplePropertyAiAssistant = ({
  value,
  remove,
  editOption,
}: IProps) => {
  const [editMode, setEditMode] = useState(false);

  return (
    <div className="list-option">
      {editMode ? (
        <TextField
          value={value}
          onChange={(e) => editOption(e.target.value)}
          onBlur={() => setEditMode(false)}
          fullWidth
          autoFocus
          inputProps={{
            style: {
              padding: 12.4,
            },
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setEditMode(false);
            }
          }}
        />
      ) : (
        <div
          className="ai-assistant-step-content-not-selected hoverable-for-edit"
          onClick={() => setEditMode(true)}
        >
          {value}
          <EditIcon className="edit-icon" />
        </div>
      )}
      <CloseMIcon
        className="close-icon"
        color={colors.grey11}
        onClick={remove}
      />
    </div>
  );
};

export default SingleOptionMultiplePropertyAiAssistant;
